export default __webpack_public_path__ + "static/media/logo.80bc01a9.png";